var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingBadge = function SvgBuildingBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#building-badge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A8378",
    d: "M6.429 5.643A.43.43 0 0 0 6 6.07v6a.43.43 0 0 0 .429.429h5.142A.43.43 0 0 0 12 12.07v-6a.43.43 0 0 0-.429-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62D3A5",
    d: "M3.875.618a.43.43 0 0 0-.591 0l-3.151 3a.43.43 0 0 0-.133.31v8.143a.43.43 0 0 0 .429.43H6.73a.43.43 0 0 0 .429-.43V3.93a.43.43 0 0 0-.134-.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A8378",
    fillRule: "evenodd",
    d: "M4.437 12.5v-1.714a.858.858 0 1 0-1.714 0V12.5zM2.398 4.383a.536.536 0 1 0 0 1.071h2.363a.536.536 0 1 0 0-1.071zm0 2.235a.536.536 0 1 0 0 1.072h2.363a.536.536 0 1 0 0-1.072z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "building-badge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h12v12H0z"
  })))));
};
export default SvgBuildingBadge;